<template>
  <div v-if="renderFilter" class="report-analytic-filter">
    <div class="filter-item" :class="useDialog && 'apply-hover'" @click="changeDialog">
      <mf-icon color="marca-0-l10" fill size="18">{{ icons[type] }}</mf-icon>
      <span class="filter-label">{{ getFilterLabel }}</span>
    </div>
    <!-- <mf-button text :label="getFilterLabel" color="marca-0-l10" fill :icon="icons[type]" @click="changeDialog" /> -->
    <chip-list-dialog
      v-if="useDialog"
      v-model="dialog"
      :title="dialogTitle[type]"
      :search-placeholder="dialogSearchPlaceholder"
      :items="this.type === 'units' && !this.items.length ? units : items"
      :headers="headers"
    />
  </div>
</template>

<script>
import ChipListDialog from '@/components/ChipListDialog.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'ReportAnalyticFilter',
  components: { ChipListDialog },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      validator: (value) => ['units', 'products', 'clientsType', 'offersScheduleIds'].includes(value),
    },
  },
  data: () => ({
    dialog: false,
    dialogTitle: {
      units: 'Lojas',
      products: 'Produtos',
      offersScheduleIds: 'Ofertas',
    },
    icons: {
      units: 'store',
      products: 'sell',
      clientsType: 'groups',
      offersScheduleIds: 'attach_money',
    },
    clientsType: {
      LEGAL_PERSON: 'PJ',
      NATURAL_PERSON: 'PF',
    },
  }),
  computed: {
    ...mapGetters(['units']),
    renderFilter() {
      return this.totalItems > 0 || this.type === 'units'
    },
    headers() {
      const typeHeaders = {
        units: [
          {
            text: 'Loja',
            value: 'name',
            width: '100%',
          },
        ],
        products: [
          {
            text: 'Nome',
            value: 'name',
            width: '80%',
          },
          {
            text: 'SKU',
            value: 'sku',
            width: '20%',
          },
        ],
      }
      return typeHeaders[this.type]
    },
    dialogSearchPlaceholder() {
      return this.useDialog ? 'Buscar ' + this.dialogTitle[this.type].toLowerCase() : ''
    },
    totalItems() {
      if (this.type === 'clientsType') {
        return this.items?.length === 1 ? 1 : 0
      } else return this.items?.length
    },
    getFilterLabel() {
      if (this.type === 'units' && (this.items.length === this.units.length || !this.items.length)) {
        return 'Todas as lojas'
      } else {
        const labels = {
          units: 'Loja',
          products: 'Produto',
          clientsType: this.type === 'clientsType' && this.totalItems === 1 ? this.clientsType[this.items[0]] : '',
          offersScheduleIds: 'Oferta',
        }

        let filterLabel = labels[this.type]
        filterLabel += this.totalItems > 1 ? 's' : ''
        return this.type === 'clientsType' ? filterLabel : `${this.totalItems} ${filterLabel}`
      }
    },
    useDialog() {
      return !['offersScheduleIds', 'clientsType'].includes(this.type)
    },
  },
  methods: {
    changeDialog() {
      if (this.useDialog) this.dialog = !this.dialog
    },
  },
}
</script>

<style lang="scss" scoped>
.report-analytic-filter {
  .filter-item {
    display: flex;
    flex-direction: row;
    gap: 4px;
    align-items: center;
    padding: 10px 5px;
    .filter-label {
      color: $marca-0-l10;
      text-align: center;
      font-size: 14px;
      font-weight: 400;
      line-height: 18px;
      letter-spacing: 0.14px;
    }
  }
  .apply-hover:hover {
    cursor: pointer;
    border-radius: 8px;
    background-color: #d2e9ff4d;
  }
}
</style>
